import axios from 'axios'
import { Store } from 'vuex'
import { Router } from 'vue-router'
import { constants } from '@/constants'
import { getBearerToken } from '@/utils/auth'

const createAxiosInstance = (baseURL: string) => {
  const instance = axios.create({
    baseURL,
    timeout: 55000
  })

  instance.interceptors.request.use(
    (configParam) => {
      const bearerToken = getBearerToken()

      if (bearerToken) {
        configParam.headers.Authorization = bearerToken
      }

      const language = localStorage.getItem('lang')

      configParam.params = {
        language,
        ...configParam.params
      }

      configParam.headers['x-market'] =
        process.env.VUE_APP_MARKET || ''

      configParam.headers.exceptiondate =
        localStorage.getItem('exceptiondate') ?? 0

      return configParam
    },

    (error) => {
      return Promise.reject(
        error instanceof Error
          ? error
          : new Error(String(error))
      )
    }
  )

  return instance
}

const createAxiosInstance_V2 = (baseURL: string) => {
  const instance_v2 = axios.create({
    baseURL,
    timeout: 55000
  })

  instance_v2.interceptors.request.use(
    (configParam) => {
      const bearerToken = getBearerToken()

      if (bearerToken) {
        configParam.headers.Authorization = bearerToken
      }

      const language = localStorage.getItem('lang')

      configParam.headers['x-market'] =
        process.env.VUE_APP_MARKET || ''

      configParam.params = {
        language,
        ...configParam.params
      }

      configParam.headers.exceptiondate =
        localStorage.getItem('exceptiondate') ?? 0
      // console.info('interceptors', configParam.params.language, configParam.headers.Authorization)

      return configParam
    },

    (error) => {
      return Promise.reject(
        error instanceof Error
          ? error
          : new Error(String(error))
      )
    }
  )

  return instance_v2
}

export const cdcServiceAPI = createAxiosInstance(constants.api.cdcService)
export const magnoliaServiceAPI = createAxiosInstance(constants.api.magnoliaService)
export const generalServiceV1API = createAxiosInstance(constants.api.generalservicev1)
export const generalServiceV2API = createAxiosInstance_V2(constants.api.generalservicev2)

const RESTRICTED_TRANSPORT_TYPES = new Set([
  'tank_tank',
  'unfiltered_unfiltered',
  'posm_posm',
  'emptiespickup_emptiespickup',
  'emptiesfulltruck_emptiesfulltruck'
])
const DEFAULT_STANDARD_ORDER = 'selfpickup_selfpickup'

export function setupCDCInterceptors (store: Store<any>, router: Router): void {
  cdcServiceAPI.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 400) {
        return Promise.reject(error instanceof Error ? error : new Error(String(error)))
      }
      store.commit('SET_GIGYA_FALLBACK', true)

      const currentShippingMethod = localStorage.getItem('shippingMethod') || ''
      if (RESTRICTED_TRANSPORT_TYPES.has(currentShippingMethod)) {
        localStorage.setItem('shippingMethod', DEFAULT_STANDARD_ORDER)
        store.commit('basket/SET_TRANSPORT_TYPE', DEFAULT_STANDARD_ORDER)
        store.dispatch('basket/CREATE_EMPTY_CART')
      }

      const currentRouteName = router.currentRoute.value.name
      if (currentRouteName !== 'homepage' && currentRouteName !== 'userVerification') {
        router.push({ name: 'homepage' })
      }
      return Promise.reject(error instanceof Error ? error : new Error(String(error)))
    }
  )
}
